import React, { useEffect } from "react";
import "./Silver.css";
import { openWhatsApp } from "../utils/whatsapp";

// ===== Import Silver Jewelry Images =====
import silverE1 from "../Assets/silverE1.jpg";
import silverE2 from "../Assets/silverE2.jpg";
import silverE3 from "../Assets/silverE3.jpg";
import silverE4 from "../Assets/silverE4.jpg";
import silverE5 from "../Assets/silverE5.jpg";
import silverE6 from "../Assets/silverE6.jpg";

import silverR1 from "../Assets/silverR1.jpg";
import silverR2 from "../Assets/silverR2.jpg";
import silverR3 from "../Assets/silverR3.jpg";
import silverR4 from "../Assets/silverR4.jpg";
import silverR5 from "../Assets/silverR5.jpg";
import silverR6 from "../Assets/silverR6.jpg";

import silverP1 from "../Assets/silverP1.jpg";
import silverP2 from "../Assets/silverP2.jpg";
import silverP3 from "../Assets/silverP3.jpg";
import silverP4 from "../Assets/silverP4.jpg";
import silverP5 from "../Assets/silverP5.jpg";
import silverP6 from "../Assets/silverP6.jpg";

import silverA1 from "../Assets/silverA1.jpg";
import silverA2 from "../Assets/silverA2.jpg";
import silverA3 from "../Assets/silverA3.jpg";
import silverA4 from "../Assets/silverA4.jpg";
import silverA5 from "../Assets/silverA5.jpg";
import silverA6 from "../Assets/silverA6.jpg";

import silverC1 from "../Assets/silverC1.jpg";
import silverC2 from "../Assets/silverC2.jpg";
import silverC3 from "../Assets/silverC3.jpg";
import silverC4 from "../Assets/silverC4.jpg";
import silverC5 from "../Assets/silverC5.jpg";
import silverC6 from "../Assets/silverC6.jpg";

import silverB1 from "../Assets/silverB1.jpg";
import silverB2 from "../Assets/silverB2.jpg";
import silverB3 from "../Assets/silverB3.jpg";
import silverB4 from "../Assets/silverB4.jpg";
import silverB5 from "../Assets/silverB5.jpg";
import silverB6 from "../Assets/silverB6.jpg";

// ===== Banner Image =====
import silverBanner from "../Assets/collection.jpeg";

const categories = [
    { id: "silver-earrings", title: "Earrings", images: [silverE1, silverE2, silverE3, silverE4, silverE5, silverE6] },
    { id: "silver-rings", title: "Rings", images: [silverR1, silverR2, silverR3, silverR4, silverR5, silverR6] },
    { id: "silver-pendant", title: "Pendant", images: [silverP1, silverP2, silverP3, silverP4, silverP5, silverP6] },
    { id: "silver-anklet", title: "Anklet", images: [silverA1, silverA2, silverA3, silverA4, silverA5, silverA6] },
    { id: "silver-necklace-chain", title: "Necklace & Chain", images: [silverC1, silverC2, silverC3, silverC4, silverC5, silverC6] },
    { id: "silver-bracelet", title: "Bracelet", images: [silverB1, silverB2, silverB3, silverB4, silverB5, silverB6] },
];

const Silver = () => {
    // Smooth scroll to section when page loads with hash
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 100);
            }
        }
    }, []);

    return (
        <div className="silver-page">
            {/* 🌟 Hero Section */}
            <section className="silver-hero" id="top">
                <img src={silverBanner} alt="Silver Collection" className="silver-hero-img" />
                <div className="silver-hero-overlay">
                    <div className="silver-hero-card">
                        <h1>Silver Collection</h1>
                    </div>
                </div>
            </section>

            {/* 💎 Each Category Section */}
            {categories.map((category, categoryIndex) => (
                <section className="silver-section" key={categoryIndex} id={category.id}>
                    <h2 className="silver-title">{category.title}</h2>
                    <hr className="silver-line" />

                    <div className="silver-grid">
                        {category.images.map((img, imgIndex) => {
                            const itemNumber = categoryIndex * 6 + imgIndex + 1;
                            const itemCode = `SS${itemNumber.toString().padStart(2, '0')}`;
                            return (
                                <div className="silver-card" key={imgIndex}>
                                    <img src={img} alt={`${category.title} ${imgIndex + 1}`} />
                                    <span>Item code: {itemCode}</span>
                                    <button className="silver-btn" onClick={() => openWhatsApp(itemCode)}>
                                        Inquire Now
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </section>
            ))}
        </div>
    );
};

export default Silver;